import * as React from 'react';
import Head from 'next/head';
import { signIn } from 'next-auth/client';
import { StoreContext } from '../utils';
import { Store } from '../store/Store';
import { runtime } from '../../classes/runtime/Runtime';

export class SigninButtonGoogleOneTap extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { requestStore } = this.context;

    return (
      <>
        <Head>
          <script src="https://accounts.google.com/gsi/client" async defer></script>
        </Head>
        <div
          id="g_id_onload"
          data-client_id="810210432835-8859ulttbat8viinpa0auvnteqegahu4.apps.googleusercontent.com"
          data-context="signin"
          data-ux_mode="redirect"
          data-login_uri={`https://${requestStore.requestData.mainHostName}/auth/signin_googleonetap`}
          data-auto_select="false"
        ></div>

        <div
          className="g_id_signin"
          data-type="standard"
          data-shape="rectangular"
          data-theme="outline"
          data-text="signin_with"
          data-size="large"
          data-locale="de"
          data-logo_alignment="center"
          data-width="320px"
        ></div>
      </>
    );
  }
}
